var _desc, _rect, _circle, _rect2, _path, _path2, _text, _text2, _path3, _path4, _g, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg102(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "1233\uD68C \uB85C\uB610 \uC608\uC0C1\uBC88\uD638 \uCD1D\uC815\uB9AC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "d"
  }, "\uB2EC\uB825\uACFC \uC5EC\uC12F \uBC88\uD638 \uACF5\uC744 \uB3C4\uD615\uC73C\uB85C \uC815\uB9AC\uD55C \uADF8\uB9BC")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    rx: 28,
    fill: "#eef7f5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 680,
    cy: 74,
    r: 108,
    fill: "#ffe7a8",
    opacity: 0.55
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 80,
    width: 250,
    height: 250,
    rx: 24,
    fill: "#fff",
    stroke: "#0f766e",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 145h250",
    stroke: "#0f766e",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125 65v45M265 65v45",
    stroke: "#172033",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 195,
    y: 225,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 58,
    fontWeight: 800,
    fill: "#172033"
  }, "7\xB718")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 195,
    y: 275,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 25,
    fontWeight: 700,
    fill: "#0f766e"
  }, "1233\uD68C \uCD94\uCCA8 \uC608\uC815")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M350 225h80",
    stroke: "#0f766e",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m410 202 28 23-28 23",
    fill: "none",
    stroke: "#0f766e",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "sans-serif",
    fontSize: 28,
    fontWeight: 900,
    textAnchor: "middle",
    fill: "#172033"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 485,
    cy: 155,
    r: 42,
    fill: "#ffd666"
  }), /*#__PURE__*/React.createElement("text", {
    x: 485,
    y: 165
  }, "?"), /*#__PURE__*/React.createElement("circle", {
    cx: 590,
    cy: 155,
    r: 42,
    fill: "#b9e6dc"
  }), /*#__PURE__*/React.createElement("text", {
    x: 590,
    y: 165
  }, "?"), /*#__PURE__*/React.createElement("circle", {
    cx: 695,
    cy: 155,
    r: 42,
    fill: "#d9ccff"
  }), /*#__PURE__*/React.createElement("text", {
    x: 695,
    y: 165
  }, "?"), /*#__PURE__*/React.createElement("circle", {
    cx: 485,
    cy: 270,
    r: 42,
    fill: "#d9ccff"
  }), /*#__PURE__*/React.createElement("text", {
    x: 485,
    y: 280
  }, "?"), /*#__PURE__*/React.createElement("circle", {
    cx: 590,
    cy: 270,
    r: 42,
    fill: "#ffd666"
  }), /*#__PURE__*/React.createElement("text", {
    x: 590,
    y: 280
  }, "?"), /*#__PURE__*/React.createElement("circle", {
    cx: 695,
    cy: 270,
    r: 42,
    fill: "#b9e6dc"
  }), /*#__PURE__*/React.createElement("text", {
    x: 695,
    y: 280
  }, "?"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 400,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 32,
    fontWeight: 900,
    fill: "#172033"
  }, "\uC77C\uC815 \uD655\uC778 \xB7 \uC870\uD569 \uBE44\uAD50 \xB7 \uC608\uC0B0 \uC900\uC218")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg102);
export default __webpack_public_path__ + "static/media/102-예상번호-총정리.7e32ff78b99c55e9e14cd51a0704971f.svg";
export { ForwardRef as ReactComponent };